import { atom, selector } from "recoil";
import {
  createBooleanAtom,
  createNumberAtom,
  createStringAtom
} from "./commonAtom";

//// 유저 정보
export const isLogInState = createBooleanAtom("isLogInState", false);
export const connectSiteState = createStringAtom("connectSiteState", "vfun");
export const userIdState = createStringAtom("userIdState", "none");
export const ssoinfoState = createStringAtom("ssoinfoState", "none");
export const userNicknameState = createStringAtom("userNicknameState", "none");
export const userBirthState = createStringAtom("userBirthState", "");
export const userProfileKeyState = createStringAtom("userProfileKeyState", "");
export const userProfileImgState = createStringAtom("userProfileImgState", "");
export const userSerialNumState = createNumberAtom("userSerialNumState", 0);
export const isProfileOwnerState = createBooleanAtom(
  "isProfileOwnerState",
  false
);
export const isProfileCreatedState = createBooleanAtom(
  "isProfileCreatedState",
  false
);

export interface userInfoProps {
  Ssoinfo: string;
  Userid: string;
  Userbirth: string;
  userSerial: number;
  channelingType: string;
}

export const userInfoState = selector<userInfoProps>({
  key: "userInfoState",
  get: ({ get }) => {
    const ssoinfo = get(ssoinfoState);
    const userId = get(userIdState);
    const userBirth = get(userBirthState);
    const userSerial = get(userSerialNumState);
    const connectSite = get(connectSiteState);

    const info = {
      Ssoinfo: ssoinfo,
      Userid: userId,
      Userbirth: userBirth,
      userSerial: userSerial,
      channelingType: connectSite
    };
    return info;
  }
});

// headersState는 api에 공통으로 들어가는 값이기 때문에 api header 넣는 용도로만 사용
export interface IHeadersProps {
  Ssoinfo: string;
  Userid: string;
  Userbirth: string;
  channelingType: string;
}

export const headersState = selector<IHeadersProps>({
  key: "headersState",
  get: ({ get }) => {
    const ssoinfo = get(ssoinfoState);
    const userId = get(userIdState);
    const userBirth = get(userBirthState);
    const connectSite = get(connectSiteState);

    const info = {
      Ssoinfo: ssoinfo,
      Userid: userId,
      Userbirth: userBirth,
      channelingType: connectSite
    };
    return info;
  }
});

// 런처
export const isLauncherState = createBooleanAtom("isLauncherState", false);

interface ILoginStateProps {
  isLogIn: boolean;
  isLauncher: boolean;
}

export const isLoginStateSelector = selector({
  key: "isLoginStateSelector",
  get: ({ get }) => {
    const isLauncher = get(isLauncherState);
    const isLogIn = get(isLogInState);

    const data: ILoginStateProps = {
      isLogIn: isLogIn,
      isLauncher: isLauncher
    };

    return data;
  }
});

//// 네이버
export const isPrivacyAgreeState = createBooleanAtom(
  "isPrivacyAgreeState",
  false
);
export const naverAuthorizeUrl = createStringAtom("naverAuthorizeUrl", "none");
